<script lang="ts">
import sectionComponent from '../components/global/section-component.vue';

export default {
  name: 'home-view',
  components: {
    sectionComponent
  },
  props: {
    title: {
      type: String,
      required: true
    }
  }
};
</script>

<template>
  <sectionComponent :class="$props.title">
    <div class="content">
      <h2 class="wp-block-heading">ASF (Nachschulung)</h2>

      <div class="wp-block-group">
        <div
          class="wp-block-group__inner-container is-layout-constrained wp-block-group-is-layout-constrained"
        >
          <h3 class="wp-block-heading">
            <span><strong>A</strong>ufbau&nbsp;</span>
            <span><strong>S</strong>eminar&nbsp;</span>
            <span>für&nbsp;</span>
            <span><strong>F</strong>ahranfänger</span>
          </h3>
        </div>
      </div>

      <p>
        Ist dir aus Versehen ein Fahrfehler passiert und hast Du eine Anordnung
        zum Aufbau Seminar bekommen, dann kannst du dich hier anmelden und wir
        erledigen den Rest für dich.
      </p>

      <p>
        Die schnellste Info bekommst Du unter:<br /><a
          href="tel:004915156449457"
          data-type="tel"
          data-id="tel:0049123456789"
          >+49 151 56449457</a
        >
      </p>

      <p>Informationen über E-Mail haben eine längere Bearbeitungszeit.</p>

      <p>
        Für Inhaber einer Fahrerlaubnis auf Probe, die wegen während der
        Probezeit begangener Verkehrsstraftaten oder -ordnungswidrigkeiten durch
        die Fahrerlaubnisbehörde mit Fristsetzung zur Teilnahme an einem
        Aufbauseminar verpflichtet wurden (Anordnung). Das Schreiben der
        Fahrerlaubnisbehörde ist bei der Anmeldung vorzulegen. Eine
        Nichtteilnahme führt zum Entzug der Fahrerlaubnis (§ 2a Abs. 3 StVG)
      </p>

      <h3 class="wp-block-heading">Ablauf</h3>

      <p>
        Das Aufbauseminar besteht aus vier Sitzungen und einer
        Beobachtungsfahrt. Die Sitzungen dauern jeweils 135 Minuten und werden
        in einem Zeitraum von zwei bis vier Wochen abgehalten. Die
        Teilnehmeranzahl muss zwischen 6 und 12 Fahranfängern liegen. Die
        Beobachtungsfahrt dauert 30 Minuten und wird zwischen der ersten und der
        zweiten Sitzung gemacht.
      </p>

      <div class="wp-block-group">
        <div
          class="wp-block-group__inner-container is-layout-constrained wp-block-group-is-layout-constrained"
        >
          <p>
            <a
              class="phone"
              href="tel:004915156449457"
              data-type="page"
              data-id="67"
            >
              +49 151 56449457
            </a>
          </p>

          <p>
            <a class="mail" href="mailto:info@asf-lk-osnabrueck.de">
              info@asf-lk-osnabrueck.de
            </a>
          </p>
        </div>
      </div>
    </div>
  </sectionComponent>
</template>

<style lang="scss">
@use 'sass:map';
@import '@/styles/variables';
@import '@/styles/colors';
@import '@/styles/mixins';

.title {
  display: flex;
  align-items: center;
  position: relative;
  color: map.get($colors, 'white');

  &::before {
    content: '';
    width: 3rem;
    height: 0.125rem;
    margin-right: 0.5rem;
    background-color: map.get($colors, 'white');
  }
}

.content {
  .wp-block-heading {
    span {
      strong {
        font-size: map.get($heading-font-sizes, 'h2');
        color: map.get($colors, 'secondary');
      }
    }
  }

  .wp-block-group {
    > * {
      display: flex;

      p {
        display: flex;
        margin: 0 1rem 0 0;

        &:last-child {
          margin-right: 0;
        }
      }

      a {
        display: inline-flex;
        align-items: center;

        &:hover::before {
          background-color: map.get($colors, 'primary');
        }

        &::before {
          content: '';
          display: block;
          width: 1.5rem;
          height: 1.5rem;
          margin-right: 0.5rem;
          mask-size: contain;
          mask-repeat: no-repeat;
          mask-position: center;
          background-color: map.get($colors, 'white');
          transition: $transition-base;
        }

        &.phone::before {
          mask-image: url('@/assets/icons/phone.svg');
        }

        &.mail::before {
          mask-image: url('@/assets/icons/mail.svg');
        }
      }

      @include media-breakpoint-down(md) {
        flex-direction: column;

        p {
          margin: 0 0 1rem;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>
